export const STATUS_GROUPS = {
  ACTIVE: 'active',
  NOT_SUBMITTED: 'not_submitted',
  DECLINED: 'declined',
  DRAFT: 'Draft',
};
